import { render, staticRenderFns } from "./MaxGameBox.vue?vue&type=template&id=2e2ed8d6&scoped=true&"
import script from "./MaxGameBox.vue?vue&type=script&lang=js&"
export * from "./MaxGameBox.vue?vue&type=script&lang=js&"
import style0 from "./MaxGameBox.vue?vue&type=style&index=0&id=2e2ed8d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2ed8d6",
  null
  
)

export default component.exports